const catalogConstants = {
  CATALOG_GET_ITEMS_REQUEST:          'CATALOG_GET_ITEMS_REQUEST',
  CATALOG_GET_ITEMS_SUCCESS:          'CATALOG_GET_ITEMS_SUCCESS',
  CATALOG_GET_ITEMS_FAILURE:          'CATALOG_GET_ITEMS_FAILURE',
  CATALOG_GET_ITEM_REQUEST:           'CATALOG_GET_ITEM_REQUEST',
  CATALOG_GET_ITEM_SUCCESS:           'CATALOG_GET_ITEM_SUCCESS',
  CATALOG_GET_ITEM_FAILURE:           'CATALOG_GET_ITEM_FAILURE',
  CATALOG_GET_ITEM_BY_SERIES_REQUEST: 'CATALOG_GET_ITEM_BY_SERIES_REQUEST',
  CATALOG_GET_ITEM_BY_SERIES_SUCCESS: 'CATALOG_GET_ITEM_BY_SERIES_SUCCESS',
  CATALOG_GET_ITEM_BY_SERIES_FAILURE: 'CATALOG_GET_ITEM_BY_SERIES_FAILURE',
  CATALOG_RESET_INITIAL_STATE:        'CATALOG_RESET_INITIAL_STATE',
  CATALOG_SET_SORT_REQUEST:           'CATALOG_SET_SORT_REQUEST',
  CATALOG_SET_SORT_SUCCESS:           'CATALOG_SET_SORT_SUCCESS',
  CATALOG_SET_SORT_FAILURE:           'CATALOG_SET_SORT_FAILURE',
  CATALOG_RESET_SORT:                 'CATALOG_RESET_SORT',
  CATALOG_SHOW_MORE_REQUEST:          'CATALOG_SHOW_MORE_REQUEST',
  CATALOG_SHOW_MORE_SUCCESS:          'CATALOG_SHOW_MORE_SUCCESS',
  CATALOG_SHOW_MORE_FAILURE:          'CATALOG_SHOW_MORE_FAILURE',

  CATALOG_ELEMENT_CHANGE_TRADE_OFFER: 'CATALOG_ELEMENT_CHANGE_TRADE_OFFER',
  CATALOG_ELEMENT_RESET:              'CATALOG_ELEMENT_RESET',
  CATALOG_ELEMENT_TABS:               'CATALOG_ELEMENT_TABS',

  CATALOG_FILTER_GET_INITIAL_STATE_REQUEST: 'CATALOG_FILTER_GET_INITIAL_STATE_REQUEST',
  CATALOG_FILTER_GET_INITIAL_STATE_SUCCESS: 'CATALOG_FILTER_GET_INITIAL_STATE_SUCCESS',
  CATALOG_FILTER_GET_INITIAL_STATE_FAILURE: 'CATALOG_FILTER_GET_INITIAL_STATE_FAILURE',
  CATALOG_FILTER_RESET:                     'CATALOG_FILTER_RESET',
  CATALOG_FILTER_SHOW:                      'CATALOG_FILTER_SHOW',
  CATALOG_FILTER_HIDE:                      'CATALOG_FILTER_HIDE',
  CATALOG_FILTER_SET_PARAM:                 'CATALOG_FILTER_SET_PARAM',

  CATALOG_STORAGE: 'CATALOG_STORAGE',
};

export default catalogConstants;